
import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-incident-register',
  templateUrl: './incident-register.component.html',
  styleUrls: ['./incident-register.component.css']
})
export class IncidentRegisterComponent implements OnChanges {
  @Input() IncidentRegisterData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  rows : any[];
  cols: any[] = [];
  header: any[] = [];
  clonedData:any[]=[];
  IsEdit:boolean = false;
  INRData : any;
  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnChanges(): void {
    if(this.IncidentRegisterData){
        this.cols = [];
        this.rows = [];
        this.header = [];
        this.header = this.IncidentRegisterData[0].Headers;
        this.rows = this.IncidentRegisterData[0].Rows;
        if(this.header){
          this.header.forEach(element => {
            this.cols.push({'field': this.header.indexOf(element),'header':element })
          });
        }
        if(this.rows){
          this.rows.forEach((element,index) => {
            element.Id = index+1;
          });
        }
    }
  }

  onRowEditInit(data: any) {
    this.clonedData[data.Id] = { ...data };
  }

  onRowEditSave(data: any,ri:number) {
    if (data.Id > 0) {
      if(this.clonedData){
        data.forEach((element,index) => {
          if(index != 0){
            if(data[index] != this.clonedData[data.Id][index]){
              this.rows[this.rows.length - 1][index] = this.rows[this.rows.length - 1][index] - this.clonedData[data.Id][index] + data[index]
            }
          }
        });
        this.clonedData = [];
      }
    }
  }

  onRowEditCancel(data: any, index: number) {
    this.clonedData = [];
  }

  GetIncidentRegisterSelectedDetails(rowdata,col){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Incident Register",
        "Component":rowdata[1] === "Total" || rowdata[1] === "" || rowdata[1] === null ? 0 : rowdata[0],
         "Column":col.field,
        "ColumnName":col.header
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetIncidentRegisterSelectedDetails.bind(this));
  }
  callbackMethodForGetIncidentRegisterSelectedDetails(response){
    if(response.Success)
    this.INRData = response.Result;
  }

  Redirect(value,UnitId)
  {
    window.open(ConstantsService.URL.APP + ['/incident/report-incident/'+value], '_self');
  }
  
  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('IncidentRegisterTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  //ws['!ref'] = ws['!ref'].replace('T','S');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "IncidentRegister.xlsx");

  }
  //EOC Pritesh

}


